import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';

/**
 * @Description this page Number Library's Random Action's configuration form
 * @Param       action - object 
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render 
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function Random({ action, variables, setOpenVariable, variableRender, setField, disabled, outputVisible }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.NUMBER.';

    return (
        <div>
            <div className="form-element">
                {t(label + 'BEGIN-RANGE')}
                <TextInput action={action} inputName="beginRange" variables={variables} setOpenVariable={setOpenVariable} isRequired={true} fieldType="number"
                    displayName={t(label + 'BEGIN-RANGE')} setField={setField} />
            </div>
            <div className="form-element">
                {t(label + 'END-OF-RANGE')}
                <TextInput action={action} inputName="endRange" variables={variables} setOpenVariable={setOpenVariable} isRequired={true} fieldType="number"
                    displayName={t(label + 'END-OF-RANGE')} setField={setField} />
            </div>
            {
                !outputVisible &&
                <div className="form-element">
                    {t('CONTENT.CONFIGURATION-FORM.STRING.ASSIGN_TO_VARIABLE')}
                    <VariablePicker action={action} inputName="set" variables={variables}
                        setOpenVariable={setOpenVariable} variableRender={variableRender} isRequired={true} disabled={disabled} />
                </div>
            }

        </div>
    )
}

